import DOMPurify from 'dompurify';

/**
 * < = &lt;
 * > = &gt;
 * " = &quot;
 * ' = &#39;
 * & = &amp;
 * space = &nbsp;
 * ¢ = &cent;
 * £ = &pound;
 * ¥ = &yen;
 * € = &euro;
 * © = &copy;
 * ® = &reg;
 *
 * @param htmlStr
 * @returns
 */
export function unEscapeHtml(htmlStr: string): string {
  return htmlStr
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'")
    .replace(/&amp;/g, '&')
    .replace(/&nbsp;/g, ' ')
    .replace(/&cent;/g, '¢')
    .replace(/&pound;/g, '£')
    .replace(/&yen;/g, '¥')
    .replace(/&euro;/g, '€')
    .replace(/&copy;/g, '©')
    .replace(/&reg;/g, '®');
}

export const stripAllHtmlTags = (value: string): string => {
  try {
    const domPurify = DOMPurify(window as unknown as Window);
    const text = domPurify.sanitize(value, {
      ALLOWED_TAGS: ['#text'],
      ALLOWED_ATTR: [],
      KEEP_CONTENT: true,
    });
    return unEscapeHtml(text.trim());
  } catch {
    return '';
  }
};
